import { Block, Button } from "framework7-react";

const GroupActions = ({ large = false, onCreate, onJoin }) => (
  <Block className="group-actions">
    <Button fill large={large} onClick={onCreate}>
      Neue Gruppe erstellen
    </Button>
    <Button raised={!large} tonal={large} large={large} onClick={onJoin}>
      Gruppe beitreten
    </Button>
  </Block>
);

export default GroupActions;
